import { map } from 'rxjs';

import { UserCellComponent } from '@core/account-ui';
import { componentOutletConfigFactory } from '@core/common-legacy';
import { injectTranslate } from '@core/i18n-legacy';
import { EMPTY_CELL } from '@core/user-interface-legacy';
import { injectUntilDestroyed } from '@core/utils-legacy';

import { defineOfferTableColumn, injectUsersMap } from './utils';
import { OfferColumnId } from '../offer-columns';

export const hiringManagerColumn = defineOfferTableColumn(() => {
  const usersMap = injectUsersMap();
  return {
    id: OfferColumnId.HiringManager,
    label: injectTranslate()('app.offers.table.hiring_manager'),
    visible: false,
    geometry: {
      width: 160,
      minWidth: 120,
      autoFitProp: 'width',
    },
    options: {
      draggable: false,
      resizable: true,
      removable: true,
      sortable: false,
    },
    componentFactory: ({ row }) => {
      if (!row.hiringManagerId) return EMPTY_CELL;

      return usersMap.pipe(
        map(users =>
          componentOutletConfigFactory(UserCellComponent, {
            inputs: { user: users[row.hiringManagerId!] },
          }),
        ),
        injectUntilDestroyed(),
      );
    },
  };
});
